export default __webpack_public_path__ + "static/delta-4c25931a565c8bfd0c88f3154a0d6c0c.png";